import React from "react"
import { BUNDLE_STATUS_CFG } from "../../utils/variables/common"
import { useTranslation } from "react-i18next"

const StatusBadge = ({ status }) => {
  const { t } = useTranslation()
  const c = BUNDLE_STATUS_CFG[status] || BUNDLE_STATUS_CFG.New

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium border ${c.bg} ${c.text} ${c.border}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      {t(`status.${c.label}`)}
    </span>
  )
}

export default StatusBadge
